import React, { Component } from 'react';

import imagen  from '../../../assets/img/header-banner-1.png';

class SubItem1 extends Component {
    state = {  }
    render() { 
        return (
            <div className="header" id = "item1">
                <div className="header-banner2" style={{backgroundImage: `url(${imagen})`, paddingLeft: "10%", paddingRight: "10%", paddingTop: 40, paddingBottom: 40}}>
                    <div style={{color:"a80012", fontSize: 30}} className="fuente-monserrat">A quiénes va dirigida</div>
                    <div align="justify" style={{color:"fff", fontSize: 16}} className="custom-mt-10 fuente-monserrat">
                        La carrera  Diseño Interior está dirigida a bachilleres creativos, innovadores y proactivos que muestren sensibilidad por el diseño, con facilidad para proponer, proyectar y dar soluciones óptimas a los espacios, con capacidad de observación y análisis del entorno y medio ambiente, inclinación por el trabajo en equipo y facilidad para el uso de nuevas tecnologías.
                    </div>
                </div>
            </div>
        );
    }
}
 
export default SubItem1;


// WEBPACK FOOTER //
// ./src/site/Componentes/DiseñoInterior/SubItem1.jsx